import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function ZeroVerFinished({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onRight: onExit});
  }, [onExit]);

  return (
    <BodyContentView
      title="Zero Verification"
      left=""
      right="Finished"
      caption="Zero Verification Complete

      Existing Zero OK
      
      Recommendation: ZERO NOT NEEDED"
    />
  );
}

export default ZeroVerFinished;
